<template>
    <footer class="footer">
        <div v-for="footerData in footerBedrijfsgegevens" :key="footerData.id">
            <partners/>
            <div class="footer--top">
                <div class="footer--address">
                    <div class="col-4 footer--address__items">
                        <span>{{ $prismic.richTextAsPlain(footerData.adres) }}</span>
                        <span>{{ $prismic.richTextAsPlain(footerData.postcode) }} {{ $prismic.richTextAsPlain(footerData.plaatsnaam) }}</span>
                        <span>{{ $prismic.richTextAsPlain(footerData.land) }}</span>
                    </div>
                    <div class="col-4 footer--address__items">
                        <span>
                            <svg version="1.1" id="icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" class="icon" viewBox="0 0 486.1 486.1" style="enable-background:new 0 0 486.1 486.1;" xml:space="preserve">
                                <g>
                                    <path d="M414.8,71.25C368.9,25.35,307.9,0.05,243,0.05s-125.9,25.3-171.8,71.2S0,178.15,0,243.05s25.3,125.9,71.2,171.8
                                        s106.9,71.2,171.8,71.2c37.7,0,72.1-7,99.4-20.1c25.9-12.5,44.7-30.4,53-50.3c9.9-23.9,4.3-48.8-15.3-68.4l-0.7-0.7
                                        c0.3-0.4,0.7-0.7,1-1c14-14.7,14-34-0.2-48.2l-34.6-34.6c-6.8-7-15-10.8-23.7-10.8s-17,3.7-24,10.7l-18,18
                                        c-0.9-0.5-1.7-0.9-2.6-1.3c-2.2-1.1-4.2-2.1-5.9-3.2c-18.3-11.6-34.9-26.8-50.8-46.3c-7-8.8-11.8-16.3-15.4-23.7
                                        c4.5-4.2,8.7-8.5,12.8-12.7c1.7-1.8,3.5-3.5,5.3-5.3c14.7-14.7,14.7-33.7,0-48.4l-17.1-17.1c-2-2-3.9-3.9-5.8-5.9
                                        c-3.8-3.9-7.7-7.9-11.9-11.8c-6.8-6.7-14.9-10.2-23.5-10.2s-16.8,3.5-23.8,10.2c-0.1,0.1-0.1,0.1-0.2,0.2l-21.5,21.5
                                        c-8.6,8.6-13.6,19.2-14.6,31.4c-1.5,19,4,36.6,8.3,48.1c10.3,27.8,25.7,53.6,48.6,81.2c27.8,33.2,61.3,59.5,99.6,78
                                        c14.7,7,34.4,15.2,56.6,16.7c1.4,0.1,2.8,0.1,4.2,0.1c15.5,0,28.6-5.6,38.8-16.7c0.1-0.1,0.3-0.3,0.4-0.4c0.3-0.4,0.7-0.8,1.1-1.2
                                        l0.6,0.6c12.8,12.8,16.3,27.4,10.1,42.3c-11.5,27.3-56.2,55.3-130.2,55.3c-120.8,0-219-98.2-219-219s98.2-219,219-219
                                        s219,98.2,219,219c0,19.9-2.7,39.5-7.9,58.4c-1.8,6.4,2,13,8.4,14.8s13-2,14.8-8.4c5.8-21,8.8-42.8,8.8-64.8
                                        C486,178.15,460.7,117.15,414.8,71.25z M343.2,349.15c-5.7,6.1-12.1,8.8-21,8.8c-0.9,0-1.8,0-2.7-0.1c-18-1.2-35-8.3-47.7-14.4
                                        c-35.1-17-65.9-41.1-91.5-71.7c-21.1-25.4-35.2-48.9-44.6-74.1c-5.6-15.2-7.7-26.8-6.9-37.8c0.6-6.5,3-11.8,7.7-16.4l21.5-21.4
                                        c1.7-1.6,4.3-3.5,7.1-3.5s5.2,1.8,6.7,3.4c0.1,0.1,0.2,0.2,0.3,0.3c3.8,3.5,7.4,7.2,11.2,11.1c2,2,4,4.1,6,6.1l17.1,17.1
                                        c5.3,5.3,5.3,9.2,0,14.5c-1.8,1.8-3.6,3.6-5.4,5.4c-5.3,5.3-10.2,10.4-15.6,15.2c-0.2,0.1-0.3,0.3-0.5,0.5
                                        c-7.5,7.5-4.9,15.3-4.1,17.9c0.1,0.3,0.2,0.5,0.3,0.8c4.6,11.1,11,21.5,20.8,33.9l0.1,0.1c17.6,21.7,36.1,38.5,56.6,51.5
                                        c2.7,1.7,5.4,3.1,8,4.4c2.2,1.1,4.2,2.1,5.9,3.2c0.3,0.2,0.7,0.4,1.1,0.6c2.6,1.3,5.2,1.9,7.8,1.9c4.4,0,8.5-1.8,12-5.4l21.5-21.5
                                        c1.7-1.7,4.2-3.7,7-3.7c2.6,0,5,1.9,6.5,3.5c0.1,0.1,0.1,0.1,0.2,0.2l34.6,34.6c4.9,4.9,4.9,9.4-0.2,14.7l-0.1,0.1
                                        c-2.3,2.5-4.8,4.9-7.5,7.5C351.4,340.35,347.2,344.45,343.2,349.15z"
                                    />
                                </g>
                            </svg>
                            <prismic-link :field="footerData.telefoon_link">+31 (0) {{ footerData.telefoon }}</prismic-link>
                        </span>
                        <span>
                            <svg version="1.1" class="icon" id="icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="20px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
                                <g>
                                    <path d="M467,76H45C20.137,76,0,96.262,0,121v270c0,24.885,20.285,45,45,45h422c24.655,0,45-20.03,45-45V121
                                      C512,96.306,491.943,76,467,76z M460.698,106c-9.194,9.145-167.415,166.533-172.878,171.967c-8.5,8.5-19.8,13.18-31.82,13.18
                                      s-23.32-4.681-31.848-13.208C220.478,274.284,64.003,118.634,51.302,106H460.698z M30,384.894V127.125L159.638,256.08L30,384.894z
                                       M51.321,406l129.587-128.763l22.059,21.943c14.166,14.166,33,21.967,53.033,21.967c20.033,0,38.867-7.801,53.005-21.939
                                      l22.087-21.971L460.679,406H51.321z M482,384.894L352.362,256.08L482,127.125V384.894z"
                                    />
                                </g>
                            </svg>
                            <prismic-link :field="footerData.emailadres_link">{{ $prismic.richTextAsPlain(footerData.emailadres) }}</prismic-link>
                        </span>
                    </div>
                    <div class="col-4 footer--address__items">
                        <span>KvK: {{ $prismic.richTextAsPlain(footerData.kvk_nummer) }}</span>
                        <span>BTW: {{ $prismic.richTextAsPlain(footerData.btw_nummer) }}</span>
                    </div>
                </div>
            </div>
            <div class="footer--bottom">
                <div class="copyright">
                    <span>
                    &copy; 2007-{{ new Date().getFullYear() }} {{ $prismic.richTextAsPlain(footerData.bedrijfsnaam) }}. All
                    rights reserved </span>
                </div>
            </div>
        </div>
    </footer>
</template>
<script>
    import Partners from "../components/Partners";

    export default {
        name: 'FooterPrismic',
        components: {
            Partners
        },
        data() {
            return {
                footerContent: [],
                footerBedrijfsgegevens: [],
            }
        },
        methods: {
            getFooter() {
                //Query to get footer content
                this.$prismic.client.getSingle('footer')
                    .then((footerContent) => {
                        this.footerContent = footerContent
                        this.footerBedrijfsgegevens = footerContent.data.bedrijfsgegevens
                    })
            },
        },
        created() {
            this.getFooter()
        }
    }
</script>


<style lang="scss">
    .footer {
        padding: 0;
        margin: 0;
        text-align: left;
        display: flex;
        flex-direction: column;
        flex-wrap: wrap;
        background: #f7f8fe;
        width: 100%;
        max-width: 100%;


        &--top {
            flex-direction: row;
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
            max-width: 1080px;
            margin: 0 auto 50px;

            @media (max-width: 500px) {
                padding: 30px;
                margin: 0;
                background: #fff;
                border-radius: 0;
            }
        }

        &--bottom {
            background: #fff;
        }


        &--address {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            flex-wrap: wrap;
            width: 100%;
            align-items: self-start;
            @media screen and (max-width: 667px) {
                flex-direction: column;
                /*justify-content: flex-start;*/
            }

            &__items {
                display: flex;
                flex-direction: column;
                align-self: center;
                @media screen and (max-width: 667px) {
                    align-self: start;
                    margin-bottom: 15px;
                }
            }
        }
    }
    .logo__bottom {
        width: 100px;
        vertical-align: middle;
        -webkit-filter: drop-shadow(-1px -1px 0px #00283d);
        filter: drop-shadow(-1px -1px 0px #00283d);
        margin: -50px auto 0;
        display: block;
    }

    .copyright {
        display: flex;
        justify-content: space-around;
        font-size: 13px;
        color: #00283d;
        font-weight: 100;
    }

    svg#icon {
        width: 21px;
        vertical-align: middle;
        margin-right: 15px;
        fill: #00283d;
    }

    sub, sup {
        position: relative;
        font-size: 75%;
        line-height: 0;
        vertical-align: baseline;
        top: -.5em;
    }
</style>
